import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';
import lottie from 'lottie-web/build/player/lottie';

class Lottie extends Component {
  constructor(props) {
    super(props);
    this.state = {
      played: false
    };
    this.containerRef = React.createRef();
    this.onVisibleChange = this.onVisibleChange.bind(this);
  }

  static propTypes = {
    animationData: PropTypes.object.isRequired,
    style: PropTypes.object,
    rendererSettings: PropTypes.object,
    loop: PropTypes.bool,
    autoplay: PropTypes.bool,
    playOnce: PropTypes.bool,
    onComplete: PropTypes.func
  };

  static defaultProps = {
    rendererSettings: {
      scaleMode: 'noScale',
      clearCanvas: false,
      progressiveLoad: true,
      hideOnTransparent: true,
      className: 'some-css-class-name'
    },
    style: {},
    loop: true,
    autoplay: false,
    playOnce: false,
    onComplete: null
  };

  componentDidMount() {
    const options = {
      animationData: this.props.animationData,
      renderer: 'svg',
      loop: this.props.loop,
      autoplay: this.props.autoplay,
      wrapper: this.containerRef.current
    };
    this.animation = lottie.loadAnimation(options);
    if (this.props.onComplete !== null) {
      this.animation.addEventListener('complete', this.afterComplete);
    }
  }

  componentWillUnmount() {
    if (this.animation) {
      this.animation.destroy();
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  afterComplete = () => {
    this.props.onComplete();
  };

  onVisibleChange(isVisible) {
    if (!this.animation) {
      return;
    }
    if (isVisible) {
      if (this.props.playOnce && this.state.played) {
        return;
      }
      this.animation.play();
      if (!this.state.played) {
        this.setState({ played: true });
      }
    }
    if (!isVisible) {
      if (!this.props.playOnce) {
        this.animation.stop();
      }
    }
  }

  render() {
    return (
      <>
        <VisibilitySensor onChange={this.onVisibleChange}>
          <div ref={this.containerRef} className="lottie-component-min" style={this.props.style} />
        </VisibilitySensor>
        <style jsx global>{`
          .lottie-component-min svg {
            display: block;
          }
        `}</style>
      </>
    );
  }
}

export default Lottie;
